import { NotificationStateSlice } from './reducer';
import { Notification } from '../../../models';

export const findNotificationsBySite = (
  rootState: NotificationStateSlice,
  siteId: number
): Notification[] => {
  return rootState.entities.notification.bySiteId[siteId] || [];
};
